import { render } from "./overcommit-config.vue?vue&type=template&id=e80fd428"
import script from "./overcommit-config.vue?vue&type=script&lang=js"
export * from "./overcommit-config.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__